var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollaricon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m70.634 112.715v8.845h-12.577v-9.26a56.649 56.649 0 0 1 -32.2-14.787l9.95-12.3a47.287 47.287 0 0 0 22.25 11.887v-26.95c-17-4.423-28.469-10.5-28.469-26.811 0-14.925 11.47-26.4 28.469-28.469v-8.43h12.577v8.569a51.408 51.408 0 0 1 29.022 12.852l-9.4 12.714a45.169 45.169 0 0 0 -19.622-10.364v25.981c18.933 4.284 31.509 10.779 31.509 27.639 0 15.894-11.471 27.502-31.509 28.884zm-12.577-59.84v-22.941c-6.771 1.658-11.057 6.495-11.057 11.885 0 5.528 3.594 8.43 11.057 11.056zm26.811 32.614c0-6.357-4.423-9.259-14.234-12.161v24.6c9.397-1.106 14.234-6.357 14.234-12.439z",
    fill: "#72bd39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollaricon);
export default __webpack_public_path__ + "static/media/dollar.icon.70e311b398fe0464d4d12fb34bf765d1.svg";
export { ForwardRef as ReactComponent };